<template>
  <div v-if="!loading" class="sp-mode">
    <header id="header">
      <b-navbar toggleable="lg">
        <b-navbar-brand class="brand">
          <a href="https://www.westjr.co.jp/"><img id="logo" src="../../assets/images/jr_logo.svg"  width="41" alt="JR西日本旅客鉄道株式会社"></a>
          <router-link id="delay" :to="{ name: 'SpSiteTop' }">遅延証明書</router-link>
        </b-navbar-brand>
      </b-navbar>
    </header>
    <article>
      <div class="message-container">
        <div class="message">
          システムメンテナンス中のため<br/>
          ただいまサービスを利用できません。<br/>
          <br/>
          ご不便をおかけいたしますが<br/>
          ご理解いただきますようお願いいたします。<br/>
        </div>
      </div>
    </article>
    <sp-site-footer/>
  </div>
</template>

<script>
import SpSiteHeader from '@/components/sp/SpSiteHeader'
import SpSiteFooter from '@/components/sp/SpSiteFooter'
import { mapState } from 'vuex'
export default {
  name: 'SpMaintenance',
  components: {
    SpSiteHeader,
    SpSiteFooter
  },
  created () {
    this.$store.commit('loading/setStatus', false)
  },
  computed: {
    ...mapState('loading', {
      loading: state => state.status
    })
  }
}
</script>

<style lang="scss" scoped>
@import '../../css/variables';
header {
  border-bottom: 1px solid #e6e6e6;
}
a {
  &#delay {
    margin-left: 16px;
    font-weight: 600;
  }
}
.brand {
  margin-left: 16px;
  strong {
    color: $primary;
    margin-left: 1rem;
    font-size: 1.2rem;
  }
}
.message-container {
  display: table;
  width: 100%;
  .message {
    height: 300px;
    font-weight: 600;
    text-align: center;
    display: table-cell;
    vertical-align: middle;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/sp/SpMaintenance.vue